import { Outlet, useNavigation } from 'react-router-dom';
import Header from "./Header";
import Footer from "./Footer";
import Loading from "../common/Loading";

const Layout = () => {
  const navigation = useNavigation();
  return (
    <>
      {navigation.state === 'loading' && <Loading />}
      <div className={`min-h-screen flex flex-col ${navigation.state === 'loading' ? 'opacity-50' : ''}`}>
        <Header />
        {/*<Navbar />*/}
        <main className="flex-grow">
          <Outlet />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Layout;
